import React from 'react';
import { siteConfig } from '../data/mock';
import { MapPin, Navigation } from 'lucide-react';

export const GoogleMapsSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Nossa Localização
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Fácil acesso em Goiânia, próximo a você
          </p>
        </div>
        
        <div className="max-w-5xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="aspect-video w-full">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3822.2769887654845!2d-49.24603242447557!3d-16.803589483869254!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935ef6f5e6e5e5e5%3A0x5e5e5e5e5e5e5e5e!2sAv.%20Bela%20Vista%2C%20Jardim%20Bela%20Vista%2C%20Aparecida%20de%20Goi%C3%A2nia%20-%20GO!5e0!3m2!1spt-BR!2sbr!4v1234567890123"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização Box7go - Avenida Bela Vista, Jardim Bela Vista, Aparecida de Goiânia"
              ></iframe>
            </div>
            <div className="p-6 md:p-8">
              <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div className="flex items-start gap-3">
                  <MapPin className="w-6 h-6 text-[#00B4D8] flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-gray-900">Avenida Bela Vista - Jardim Bela Vista</p>
                    <p className="text-gray-600">Aparecida de Goiânia - GO</p>
                  </div>
                </div>
                <a
                  href={siteConfig.googleMaps}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-[#00B4D8] hover:bg-[#0096C7] text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300 hover:scale-105"
                >
                  <Navigation className="w-5 h-5" />
                  Como Chegar
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
